<template>
    <div class="contain" style="padding: 2.25rem 5vw">
        <div style="display: flex; flex-wrap: wrap; justify-content: space-between">
            <div style="font-size: 2rem; line-height: 2rem; font-weight: bold; color: #b62d2e">
                學生帳戶及表現 <span style="white-space: nowrap">Student Account</span>
                <div style="display: flex; margin-top: 0.5rem; margin-bottom: 1rem">
                    <span style="width: 1rem; height: 1rem; background: #b62d2e; border-radius: 50%; margin-right: 1rem"></span>
                    <span style="width: 1rem; height: 1rem; background: #de5934; border-radius: 50%; margin-right: 1rem"></span>
                    <span style="width: 1rem; height: 1rem; background: #f1aa55; border-radius: 50%; margin-right: 1rem"></span>
                </div>
            </div>
            <div class="purchase-box" style="flex-wrap: wrap">
              <div>
                <el-badge v-if="needRenew" is-dot class="item">
                  <el-button style="color: #fff;" size="medium" type="warning" :class="needRenew ? '' : 'disabled'" :disabled="!needRenew" @click="onRenew">
                    續訂 Renew
                  </el-button>
                </el-badge>
                  <el-button v-if="!needRenew" size="medium" type="warning" :class="needRenew ? '' : 'disabled'" :disabled="!needRenew" @click="onRenew">
                    續訂 Renew
                  </el-button>
                <el-button size="medium" style="color: #fff;margin-left: 5px" type="warning" @click="addStudent">增加學生 Add Student</el-button>
              </div>

            </div>
        </div>
        <div class="student-box" v-if="studentCardList && studentCardList.length > 0">
            <el-row :gutter="40" type="flex" style="flex-wrap: wrap">
                <el-col :xs="24" :sm="24" :lg="8" v-for="(item, index) in studentCardList" :key="index">
                    <div class="card-box">
<!--                        <img :src="item.avatar || require('@/assets/images/student-default-avatar.png')" />-->
                        <div class="card-detail">
                          <div class="card-detail-text">
                            <div class="font-500">帳戶頭像 Avatar</div>
                            <div><el-avatar size="small" :src="item.avatar || require('@/assets/images/student-default-avatar.png')"></el-avatar></div>
                          </div>
                            <div class="card-detail-text">
                                <div class="font-500">帳戶名稱 Username</div>
                                <div>{{ item.userNo }}</div>
                            </div>
                            <div class="card-detail-text">
                                <div class="font-500">訂閱狀態 Status</div>
                                <div v-if="item.subscriptions.length > 0 && !isNaN(item.subscriptionIndex)">
                                    <span
                                        :class="
                                            checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) != 0
                                                ? 'text-warn'
                                                : ((item.subscriptions[item.subscriptionIndex].upgradeWill == 1 && item.subscriptions[item.subscriptionIndex].upgradedType == 1) ||
                                                      item.subscriptions[item.subscriptionIndex].upgradeWill == 2) &&
                                                  item.gradeId != 6
                                                ? 'text-info'
                                                : 'text-success'
                                        "
                                    >
                                        {{
                                            checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) == 0
                                                ? "訂閱中"
                                                : checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) == 1
                                                ? "即將過期"
                                                : checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) == 2
                                                ? "過期"
                                                : "到期"
                                        }}
                                    </span>
                                    <span>{{ item.branchSchool!=null && item.branchSchool.abbreviation!='HQ'?"":"(" + formatDate(item.subscriptions[item.subscriptionIndex].endDate) + " 完結)" }}</span>
                                </div>
                                <div v-else>---</div>
                            </div>
                            <div class="card-detail-text">
                                <div class="font-500">年級 Level</div>
                                <div v-if="item.subscriptions.length > 0 && !isNaN(item.subscriptionIndex)">
                                    {{ item.subscriptions[item.subscriptionIndex].gradeName }}
                                    {{ `(${item.subscriptions[item.subscriptionIndex].totalStar}/${item.subscriptions[item.subscriptionIndex].fullStar} 星星)` }}
                                </div>
                                <div v-else>---</div>
                            </div>
                            <div class="card-detail-text">
                                <div class="font-500">性別 Gender</div>
                                <div v-if="item.gender == 0 || item.gender == 1">
                                    {{ genders[item.gender].label }}
                                </div>
                                <div v-else>---</div>
                            </div>
                            <div class="card-detail-text">
                                <div class="font-500">生日 Date of Birth</div>
                                <div>{{ formatDate(item.birthday) || "---" }}</div>
                            </div>
                            <div class="card-detail-text">
                                <div class="font-500">付款方法 Payment Method</div>
                                <div v-if="item.subscriptions.length > 0 && !isNaN(item.subscriptionIndex)">
                                    {{ paymentType[item.subscriptions[item.subscriptionIndex].type] }}
                                </div>
                                <div v-else>---</div>
                            </div>
                          <div class="card-detail-text">
                            <div class="font-500">中心</div>
                            <div v-if="item.branchSchool != null">
                              {{ item.branchSchool.abbreviation }}-{{ item.branchSchool.nameZh }}
                            </div>
                            <div v-else>HQ</div>
                          </div>
                          <div class="card-detail-text">
                            <div class="font-500">語言版本</div>
                            <div>
                              {{item.studying==0?'繁體語言':'English'}}
                            </div>
                          </div>
                          <div class="action-buttons">
                            <el-button style="color: #fff;" size="mini" type="warning" @click="onEditStudentAccount(item.id, index)">編輯 Edit</el-button>
                            <el-button style="color: #fff;" size="mini" type="warning" @click="onDetailStudent(item)">查看表現 Check</el-button>
                            <el-button style="color: #fff;" size="mini" type="warning" @click="switchStudentLogin(item)">開始學習 Start Learning</el-button>

                          </div>

                        </div>
<!--                        <div v-if="!item.birthday || item.gender == null" class="box-warn text-warn" style="line-height: 1.6rem"><i class="el-icon-warning-outline box-icon"></i>請輸入學生資料。</div>-->
                        <div v-if="item.subscriptions.length > 0 && !isNaN(item.subscriptionIndex)">
                            <div v-if="(checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) == 1||checkDate(item.subscriptions[item.subscriptionIndex].endDate) == 3,item.branchSchool) && item.subscriptionIndex > 0" class="box-success text-success" style="align-items: center">
                                <i class="el-icon-circle-check box-icon"></i>
                                <div>
                                    <div>
                                        最新訂閱 ({{ formatDate(item.subscriptions[0].endDate) }} 完結)
                                    </div>
                                    <div>年級：{{ item.subscriptions[0].gradeName }}</div>
                                </div>
                            </div>
                            <div v-if="needUpgrade && item.gradeId != 6">
                                <div
                                    v-if="item.subscriptions[item.subscriptionIndex].upgradeWill == 1 && item.subscriptions[item.subscriptionIndex].upgradedType != 1"
                                    class="box-success text-success"
                                    style="line-height: 1.6rem"
                                >
                                    <i class="el-icon-circle-check box-icon"></i>此學生將於 {{ showUpgradeDate() }} 升級。This student will be upgrade at {{ showUpgradeDate() }}.
                                </div>
                                <div
                                    v-if="item.subscriptions[item.subscriptionIndex].upgradeWill == 1 && item.subscriptions[item.subscriptionIndex].upgradedType == 1"
                                    class="box-info text-info"
                                    style="line-height: 1.6rem"
                                >
                                    <i class="el-icon-circle-check box-icon"></i>此學生已於
                                    {{ formatDate(item.subscriptions[item.subscriptionIndex].upgradedAt) }}
                                    手動升級。
                                </div>
                                <div v-if="item.subscriptions[item.subscriptionIndex].upgradeWill == 2" class="box-info text-info" style="line-height: 1.6rem">
                                    <i class="el-icon-warning-outline box-icon"></i>此學生將於 {{ showUpgradeDate() }} 保留原級。This student will retain his or her current grade.
                                </div>
                                <div v-if="item.subscriptions[item.subscriptionIndex].upgradeWill == 0" class="box-info text-info" style="font-weight: bold; padding-bottom: 0">
                                    <div>
                                        <i class="el-icon-star-on box-info-icon"></i>想為你的小朋友在新學年升班嗎？Upgrade your child account?
                                        <p style="font-weight: 400">
                                            <!-- （說明）必約視權其日圖查聲裡起元父去整體很中海感風醫充、票真聲風視動北生日想對服子數，有視電向不日理要音寫後留裡電求樣。 -->
                                        </p>
                                        <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
                                            <button
                                                @click="upgradeWill(1, item.id, item.subscriptions[item.subscriptionIndex].id)"
                                                class="card-button cursor-pointer"
                                                style="margin-right: 1.5rem; background: #fcc03a; line-height: 1.25; min-height: 38px; margin-bottom: 1.25rem"
                                            >
                                                確認升級 Upgrade
                                            </button>
                                            <button
                                                @click="upgradeWill(2, item.id, item.subscriptions[item.subscriptionIndex].id)"
                                                class="card-button cursor-pointer"
                                                style="background: #fcc03a; width: 110px; line-height: 1.25; margin-bottom: 1.25rem"
                                            >
                                                留在原有年級 No, stay here
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog custom-class="loading-box" :visible.sync="dialogVisible" :width="$store.getters.isPC ? '65%' : '90%'" :close-on-click-modal="false">
            <editStudentProfile :detail="detail" :formLabelAlign="studentAccountFrom" :studentIndex="studentIndex" @childByValue="childByValue"></editStudentProfile>
        </el-dialog>
      <loadingDialog :center-dialog-visible="centerDialogVisible"></loadingDialog>
    </div>
</template>

<script>
import { gender, paymentType } from "@/biz/static-data";
import {setToken, setUserInfo} from "@/utils/auth";
import { formatDate } from "@/filters";
import { upgradeWill } from "@/api/subscription";
import { getSubscriptionUpgradeDates } from "@/api/setting";
import editStudentProfile from "./editStudentProfile";
import moment from "moment";
import {switchStudentLogin} from "@/api/security";
import {getProfile} from "@/api/user";
import loadingDialog from "@/components/loadingDialog";
export default {
    components: { editStudentProfile,loadingDialog },
    props: {
        detail: {
            type: Object,
            default: function () {},
        },
    },
    data() {
        return {
          centerDialogVisible: false,
          form: {
            userNo: "",
            password: "",
          },
            studentAccountFrom: {
                id: null,
                userNo: null,
                name: null,
                gender: null,
                school: null,
                password: null,
                gradeId: null,
                avatar: null,
            },
            studentCardList: [],
            paymentType: [],
            studentIndex: null,
            dialogVisible: false,
            confirmUpgradeDate: "",
            autoUpgradeDate: "",
        };
    },
    watch: {
        "$store.getters.language": {
            handler(v) {
                //  this.getCarts()
                this.genders = gender[v];
                this.paymentType = paymentType[v];
                this.$forceUpdate();
            },
            deep: true,
        },
        detail(v) {
            this.studentCardList = v.students.filter((item) => {
                return item.subscriptions.length > 0 && item.status == 1;
            });
            this.$forceUpdate();
        },
    },
    computed: {
        needRenew() {
            let need = false;
            if (this.detail.students && this.detail.students.length > 0) {
                this.detail.students.forEach((item) => {
                    if (item.status == 1 && !item.studentCode) {
                        if (item.subscriptions.length > 0 && !isNaN(item.subscriptionIndex) && item.subscriptionIndex == 0 && this.checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) != 0)
                            need = true;
                        if (item.subscriptions.length == 0) need = true;
                    }
                });
            }
            return need;
        },
        needUpgrade() {
            if (this.confirmUpgradeDate && this.autoUpgradeDate) return this.$options.filters["isBetween"](new Date(), this.confirmUpgradeDate, this.autoUpgradeDate);
            else return false;
        },
    },
    created() {},
    mounted() {
        this.paymentType = paymentType[this.$store.getters.language];
        if (this.detail.students) {
            this.studentCardList = this.detail.students.filter((item) => {
                return item.subscriptions.length > 0 && item.status == 1;
            });
        }
        getSubscriptionUpgradeDates().then((v) => {
            let year = new Date().getFullYear() + "-";
            this.confirmUpgradeDate = year + v.data.confirmUpgradeDate;
            this.autoUpgradeDate = year + v.data.autoUpgradeDate;
        });
    },
    methods: {
        onRenew() {
            this.$router.push({
                name: "subscribe",
                query: { id: this.detail.id, isRenew: true },
            });
        },
        addStudent() {
            this.$router.push({ name: "subscribe", query: { id: this.detail.id } });
        },
        formatDate(date) {
            return formatDate(date);
        },
        showUpgradeDate() {
            if (moment(new Date()).isBefore(this.autoUpgradeDate)) return formatDate(this.autoUpgradeDate);
            else return formatDate(moment(this.autoUpgradeDate).add(1, "y"));
        },
        getThreeMonthAgo(endDate) {
            var a = moment();
            var b = moment(endDate);
            return b.diff(a, "months");
        },
        //0:30天外,订阅中；1:30天内,即将过期;2:过期;3:到期(当天)
        checkDate(endDate,branchSchool) {
            let status = 0;
            if (this.getThreeMonthAgo(endDate) <= 3) {
                status = 1;
            }
            if (moment().format("YYYY-MM-DD") == moment(endDate).format("YYYY-MM-DD")) {
                status = 3;
            }
            if (moment().format("YYYY-MM-DD") > moment(endDate).format("YYYY-MM-DD")) {
                status = 2;
            }
            //分校学生：订阅中
            if(branchSchool != null){
              if(branchSchool.abbreviation != 'HQ'){
                status = 0;
              }
            }
            return status;
        },
        onEditStudentAccount(id, index) {
            this.studentIndex = this.detail.students.findIndex((item) => item.id == id);
            this.studentAccountFrom = JSON.parse(JSON.stringify(this.studentCardList[index]));
            this.studentAccountFrom.password = "";
            this.dialogVisible = true;
        },
        onDetailStudent(item) {
            if (item.subscriptions.length > 0 && !isNaN(item.subscriptionIndex))
                this.$router.push({
                    path: "/studyRecord",
                    query: {
                        id: item.id,
                        studentName: item.userNo,
                        gradeId: item.subscriptions[item.subscriptionIndex].gradeId,
                        studying: item.studying,
                    },
                });
            else
                this.$router.push({
                    path: "/studyRecord",
                    query: { id: item.id, studentName: item.userNo,studying: item.studying},
                });
        },
      switchStudentLogin(item) {
        this.centerDialogVisible = true;
        if(this.checkDate(item.subscriptions[item.subscriptionIndex].endDate,item.branchSchool) == 2){
          this.$message.warning('請先訂閱課程！');
          this.centerDialogVisible = false;
          return
        }
        this.form.userNo = item.userNo;
        this.form.password = item.password;
        let that = this
        switchStudentLogin(this.form)
            .then((v) => {
              setUserInfo("userInfo", v.data);
              setUserInfo("refreshToken", v.data.refreshToken);
              setToken(v.data.accessToken);
              getProfile().then((v) => {
                this.detail = JSON.parse(JSON.stringify(v.data));
                this.detail.subscriptionIndex = 0;
                setUserInfo("userProfile", this.detail);
                this.$store.dispatch("setGradeId", this.detail.subscriptions[this.detail.subscriptionIndex].gradeId);
                setTimeout(() => {
                  this.centerDialogVisible = false;
                  that.$router.push({ path: "/studentProgramme" }).catch(() => {});
                }, 500);
              });
            })
      },
        childByValue(v) {
            this.dialogVisible = v;
            this.$emit("getProfile");
            this.$forceUpdate();
        },
        upgradeWill(value, studentId, subscriptionId) {
            let index = this.detail.students.findIndex((item) => item.id == studentId);
            upgradeWill(subscriptionId, { upgradeWill: value }).then(() => {
                this.detail.students[index].subscriptions[this.detail.students[index].subscriptionIndex].upgradeWill = value;
                this.detail.students[index].subscriptions[this.detail.students[index].subscriptionIndex].upgradedType = 0;
                setUserInfo("userProfile", this.detail);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.contain {
    //width: 100%;
    display: flex;
    flex-direction: column;
}
.purchase-box {
    display: flex;
    justify-content: flex-end;
    position: relative;
    //margin-top: -4.5rem;
    height: 3.75rem;
    height: 3.75rem;
}
.el-icon-warning {
    font-size: 2rem;
    color: #d20000;
    position: absolute;
    top: -1rem;
    margin-left: 1rem;
}
.student-box {
    margin-top: 1rem;
}
.card-box {
    margin-bottom: 1.25rem;
    padding: 1rem;
    background: #f1aa55 url("~@/assets/images/student-card.png") top left/64% auto;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    img {
        margin: 1rem auto;
        width: 3.5rem;
        height: 3.5rem;
    }
    .card-detail {
        background: #ffffff;
        padding: 1.25rem 1.75rem;
        border-radius: 1rem;
        .card-detail-text {
            padding-bottom: 1rem;
            display: flex;
            div:nth-child(1) {
                color: #8e8e8e;
                flex: 1;
            }
            div:nth-child(2) {
                color: #444444;
                flex: 2;
            }
        }
    }
    .text-warn {
        color: #d20000;
    }
    .text-success {
        color: #008000;
    }
    .text-info {
        color: #936a10;
    }
    .box-warn {
        background: #fbe6e6;
        border: 1px #d20000 solid;
        margin-top: 1.25rem;
        padding: 1.25rem 1.75rem;
        border-radius: 1rem;
        display: flex;
    }
    .box-success {
        background: #e6f2e6;
        border: 1px #008000 solid;
        margin-top: 1.25rem;
        padding: 1.25rem 1.75rem;
        border-radius: 1rem;
        display: flex;
    }
    .box-info {
        background: #fffbe6;
        border: 1px #ffd700 solid;
        margin-top: 1.25rem;
        padding: 1.25rem 1.75rem;
        border-radius: 1rem;
        display: flex;
    }
    .box-icon {
        font-size: 1.6rem;
        margin-right: 0.5rem;
    }
    .box-info-icon {
        font-size: 1.2rem;
        padding: 0.2rem;
        line-height: 1;
        margin-right: 0.5rem;
        color: #fffbe6;
        background: #fcc03a;
        border-radius: 50%;
    }
}
.detail-button {
    border: 0.0625rem solid #fcc03a;
    font-weight: bold;
    color: #444444;
    border-radius: 1.625rem;
    font-size: 18px;
    line-height: 1;
    padding: 0.75rem 2.25rem;
    background: #fcc03a;
    margin-bottom: 0.5rem;
    &.disabled {
        opacity: 0.6;
    }
}
.card-button {
    border: 0.0625rem solid #fcc03a;
    font-weight: bold;
    color: #444444;
    border-radius: 1.625rem;
    line-height: 1.25;
    min-height: 2.2rem;
    background: #ffffff;
}

@media (min-width: $minWidth) and (max-width: $maxWidth) {
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .contain {
        height: 100%;
    }
    .el-dialog__wrapper {
        top: auto;
    }
}
::v-deep {
    .el-dialog {
        border-radius: 2.25rem;
        .el-dialog__headerbtn {
            font-size: 1.6rem;
            top: 2rem;
            right: 2rem;
        }
        .el-dialog__body {
            padding: 3rem 1.25rem;
        }
    }
}
/* 三个按钮 自动适配手机 */
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
  justify-content: flex-start;
}
.action-buttons button {
  flex: 1;
  min-width: 100px;
  white-space: nowrap;
}
</style>
